import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cw-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/users/user-detail/user-detail.component.ts